export enum DocumentTypeEnum {
    ISPO = "Purchase Orders",
    DOCUMENTS = "Documents",
}
